import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from "@angular/core";
import { WidgetRepartitionParClientComponent } from "../../../dashboard/components/widget-repartition-par-client/widget-repartition-par-client.component";
import { ArticleFacadeService } from "../../services/article/article-facade.service";
import { ArticlesInfosFacadeService } from "../../services/article-infos/article-infos-facade.service";
import { Widget } from "../../../dashboard/models/dashboard.model";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { CaGroupBy } from "../../../dashboard/models/data.model";
import { repartitionCaFromStatsArticle } from "./repartition-ca-article-from-stats.util";

/**
 * Widget Répartition CA dédié à la page Stats Article.
 *
 * Wrappe `vl-widget-repartition-par-client` en le nourrissant avec les
 * statistiques de l'article courant (facturesLignes + ofs). Reprend
 * automatiquement les évolutions du widget partagé (toggle MO, toggle remise
 * pied, niveau article intercalé en mode `byGroupeTiers`, etc.).
 *
 * Remplace les widgets historiques `VentesParClientComponent` et
 * `MargeParTiersComponent` qui exposaient une vue plus pauvre (doughnut/bar
 * sans détail par lot ni toggle).
 */
@Component({
  selector: "vl-repartition-ca-article",
  standalone: true,
  imports: [WidgetRepartitionParClientComponent],
  host: { class: "widget-component" },
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <vl-widget-repartition-par-client
      [data]="data()"
      [widget]="widget()"
      [metadata]="metadata()"
      [hidePeriod]="true"
      [availableGroupBy]="availableGroupBy"
      [customTitle]="'Répartition CA'"
      storageKey="justup-widget-repartition-ca-article"
    />
  `,
})
export class RepartitionCaArticleComponent {
  widget = input<Widget>();
  metadata = input<EntityMetadata>();

  private articleFacade = inject(ArticleFacadeService);
  private articleInfosFacade = inject(ArticlesInfosFacadeService);
  private stats = this.articleFacade.getState().stats;

  /** Sur une page scopée à un seul article, "Article" et "Famille" n'ont
   *  qu'un seul item — on les masque. Reste pertinent : Client / Groupe. */
  availableGroupBy: CaGroupBy[] = ["byClient", "byGroupeTiers"];

  data = computed(() =>
    repartitionCaFromStatsArticle(this.stats(), this.articleInfosFacade),
  );
}
